import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Highlighter from 'react-highlight-words';

import Avatar from './Avatar';

export default class MentionsPicker extends Component {
  static propTypes = {
    style: PropTypes.object,
    options: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired,
      avatar: PropTypes.string,
      type: PropTypes.string,
    })),
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
    searchWords: PropTypes.arrayOf(PropTypes.string),
    selected: PropTypes.number,
    loading: PropTypes.bool,
  }

  static defaultProps = {
    style: {},
    options: [],
    onClick() {},
    onMouseEnter() {},
    searchWords: [],
    selected: 0,
    loading: false,
  }

  renderLoading() {
    // So that the menu doesn't change height while loading, use the same number
    // of options, or a max of 5, since that's what we show before scrolling
    const count = Math.min(this.props.options.length || 1, 5);
    const items = [];

    for (let i = 0; i < count; i += 1) {
      items.push(
        <li key={`loading-${i}`} className="MentionsPicker-option is-loading" />
      );
    }
    return items;
  }

  renderOptions() {
    return this.props.options.map((option, index) =>
      <li key={option.key}
        className={`MentionsPicker-option ${
          index === this.props.selected ? 'is-active' : ''
        }`}
        onClick={this.props.onClick.bind(this, option)}
        onMouseEnter={this.props.onMouseEnter.bind(this, index)}
      >
        <Avatar className="MentionsPicker-avatar"
          name={option.title}
          src={option.avatar}
          type={option.type}
        />
        <div className="MentionsPicker-title">
          { option.title }
        </div>
        <Highlighter
          className="MentionsPicker-subtitle"
          highlightClassName="u-mark"
          searchWords={this.props.searchWords}
          textToHighlight={option.subtitle}
        />
      </li>
    );
  }

  render() {
    if (this.props.options.length === 0 && !this.props.loading) {
      return null;
    }
    return (
      <ul
        className="MentionsPicker"
        style={this.props.style}
      >
        { this.props.loading ? this.renderLoading() : this.renderOptions() }
      </ul>
    );
  }
}
